/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ConditionType = "contains" | "endsWith" | "equals" | "greaterThan" | "greaterThanOrEqual" | "inRange" | "lessThan" | "lessThanOrEqual" | "notContains" | "notEqual" | "startsWith" | "%future added value";
export type FilterType = "date" | "number" | "text" | "%future added value";
export type OperatorType = "AND" | "OR" | "%future added value";
export type Filter = {|
  name: string,
  filterType: FilterType,
  operator: OperatorType,
  denySelection?: ?boolean,
  conditions: $ReadOnlyArray<?Condition>,
|};
export type Condition = {|
  value: $ReadOnlyArray<?string>,
  type: ConditionType,
|};
export type Filter3MaintenanceServiceProvidedCountQueryVariables = {|
  companyId: string,
  filters?: ?$ReadOnlyArray<?Filter>,
|};
export type Filter3MaintenanceServiceProvidedCountQueryResponse = {|
  +Me: ?{|
    +id: string,
    +Company: ?{|
      +data: number
    |},
  |}
|};
export type Filter3MaintenanceServiceProvidedCountQuery = {|
  variables: Filter3MaintenanceServiceProvidedCountQueryVariables,
  response: Filter3MaintenanceServiceProvidedCountQueryResponse,
|};
*/


/*
query Filter3MaintenanceServiceProvidedCountQuery(
  $companyId: ID!
  $filters: [Filter]
) {
  Me {
    id
    Company(id: $companyId) {
      data: countAppointments(options: {filters: $filters})
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "companyId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filters"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "companyId"
  }
],
v3 = {
  "alias": "data",
  "args": [
    {
      "fields": [
        {
          "kind": "Variable",
          "name": "filters",
          "variableName": "filters"
        }
      ],
      "kind": "ObjectValue",
      "name": "options"
    }
  ],
  "kind": "ScalarField",
  "name": "countAppointments",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "Filter3MaintenanceServiceProvidedCountQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "Me",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "Company",
            "plural": false,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "Filter3MaintenanceServiceProvidedCountQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "Me",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "Company",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v1/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "be5ee52a2fc1136d7fbc15d9a8d659ad",
    "id": null,
    "metadata": {},
    "name": "Filter3MaintenanceServiceProvidedCountQuery",
    "operationKind": "query",
    "text": "query Filter3MaintenanceServiceProvidedCountQuery(\n  $companyId: ID!\n  $filters: [Filter]\n) {\n  Me {\n    id\n    Company(id: $companyId) {\n      data: countAppointments(options: {filters: $filters})\n      id\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '6fc378aaec87658ecceb89420ab70f19';

module.exports = node;
